import $ from "jquery";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { callGetApi, callPostApi } from "../../api/ApiCaller";
import { GET_GAME_PLAY_RESULT_POST, GET_PLAYER_BALANCE_GET, GET_TEMPLATE_DETAILS_GET, RESET_BALANCE_AMT_POST, ADD_BALANCE_AMT_POST } from "../../api/ApiConst";
import { CURRENCY_CODE, getAudioVolume, getDataFromStore, setAudioVolume, TEMPLATE_ID } from "../../utils/CookiesUtils";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";
import ModalHalloween from "../common/ModalHalloween";
import AccumuladoOverlay from "../ice-game/AccumuladoOverlay";
import JackpotFly from "../ice-game/JackpotFly";

// This game has exactly TWO bonus rounds — the fridge (geladeira) and the
// basket (cesta). There is no third one: any other bonusType is ignored.
import RefrigeratorBonus from "../bonus/RefrigeratorBonus";
import BasketBonus from "../bonus/BasketBonus";

// Ice UI
import "../ice-game/IceGamePlay.css";
import IceHeader from "../ice-game/IceHeader";
import IceFooter from "../ice-game/IceFooter";
import IceMainContainer, { INITIAL_REELS } from "../ice-game/IceMainContainer";
import BonusOverlay from "../ice-game/BonusOverlay";

// Halloween_20 pay-line options
const LINE_OPTIONS = [1, 5, 9, 15, 20];

// The only two bonusType values this game reacts to. Both play the BÔNUS splash
// first and then open their own bonus, which fetches its prizes from getBonusResult.
// The basket string is confirmed off a live getGamePlayResult response.
// TODO: confirm the fridge string the same way — it is still a guess.
const FRIDGE_BONUS_TYPE = "Bonus13Refrigerator";
const BASKET_BONUS_TYPE = "Bonus12PenguinBasket";

// AJUDA (help) pages, shown one at a time in the table modal
const AJUDA_IMAGES = Array.from({ length: 7 }, (_, i) => `ice-assets/table/ajuda_${i + 1}.png`);

// API resultMatrix ([3 rows][5 cols] of {title}) -> ice reels ([5 cols][3 rows])
const matrixToReels = (matrix) => {
    if (!Array.isArray(matrix) || matrix.length < 3) return INITIAL_REELS;
    return Array.from({ length: 5 }, (_, col) =>
        Array.from({ length: 3 }, (_, row) => matrix[row]?.[col]?.title || "abobora")
    );
};

// payLines[].title looks like "line-show7" -> 7
const payLineNumbers = (payLines) =>
    (payLines || [])
        .map((p) => parseInt(String(p.title).replace("line-show", ""), 10))
        .filter((n) => !isNaN(n));

// WILD substitutes for any symbol on a line
const ICE_WILD = "spriteElement03";
const MIN_RUN = 3;

// The machine pays both ways: a line also wins with 3+ matching symbols ending on
// reel 5 (right to left). The server only flags `isValidToDrawLine` on the
// left-to-right runs, so a right-to-left win drew its line but nothing animated.
// Rebuild the winning cells from the result matrix, from both ends of the line.
const lineRunCells = (pl, matrix) => {
    const coords = [...(pl.line || [])].sort((a, b) => a.y - b.y);
    const titles = coords.map((c) => String(matrix?.[c.x]?.[c.y]?.title ?? ""));
    const run = (order) => {
        let base = null;
        let len = 0;
        for (const i of order) {
            const t = titles[i];
            if (!t) break;
            if (t !== ICE_WILD) {
                if (base === null) base = t;
                else if (t !== base) break;
            }
            len++;
        }
        return order.slice(0, len);
    };
    const idx = coords.map((_, i) => i);
    const cells = [];
    [run(idx), run([...idx].reverse())].forEach((r) => {
        if (r.length >= MIN_RUN) r.forEach((i) => cells.push({ x: coords[i].x, y: coords[i].y }));
    });
    return cells;
};

const HalloweenIceGame = () => {
    const navigate = useNavigate();
    const templateId = getDataFromStore(TEMPLATE_ID);
    const [templateData, setTemplateData] = useState(null);
    const [walletBalance, setWalletBalance] = useState(0);
    const [accumuladoList, setAccumuladoList] = useState([]);

    const [reels, setReels] = useState(INITIAL_REELS);
    const [animateColumn, setAnimateColumn] = useState([false, false, false, false, false]);
    const [gameResult, setGameResult] = useState(null);
    const [winnings, setWinnings] = useState(0);
    const [winningLines, setWinningLines] = useState([]);
    const [linePreview, setLinePreview] = useState(true); // show selected line paths only while choosing lines
    const [bonusLines, setBonusLines] = useState(null);   // { lineNumber: winValue } → bonus-line overlays + numbers
    const [highlightCells, setHighlightCells] = useState([]); // winning symbol coords ({x: row, y: col})
    const [pagoWinningCounter, setPagoWinningCounter] = useState(null);
    // true while a free play payout runs: Pago then counts up instead of holding the total
    const [pagoCountsUp, setPagoCountsUp] = useState(false);

    const [selectedNumber, setSelectedNumber] = useState(1);
    const [betMultiplier, setBetMultiplier] = useState(null);
    const [denomination] = useState(0.01);

    const [slotRunning, setSlotRunning] = useState(false);
    const [buttonFlag, setButtonFlag] = useState(false);       // disables Ajuda / Auto / Apostar
    const [jogarButtonFlag, setJogarButtonFlag] = useState(false); // disables Jogar
    const [showInsufficientFundModel, setShowInsufficientFundModel] = useState(false);
    const [resetAmntModel, setResetAmntModel] = useState(false);

    const [autoBetOn, setAutoBetOn] = useState(false);
    const [autoCount, setAutoCount] = useState(0);
    const [playMachine, setPlayMachine] = useState(0);
    const [showAutoNumberPickerModel, setShowAutoNumberPickerModel] = useState(false);

    const [showHelpModel, setShowHelpModel] = useState(false);
    const [currentIndexOfHelpSlide, setCurrentIndexOfHelpSlide] = useState(0);
    const [showCoins, setShowCoins] = useState(false);
    const [jackpotFlies, setJackpotFlies] = useState([]);   // pieces of the pot in flight to Ganhou: { id, amount, onArrive }
    const [accumuladoWin, setAccumuladoWin] = useState({ winAmount: 0, winIndex: -1 });
    const [keyboardInput, setKeyboardInput] = useState(false);
    // bonus flow: the BÔNUS splash plays first, then the bonus the API asked for
    // opens underneath it. `activeBonus` holds that bonusType until the round ends;
    // it is only ever set from gameResult.bonusType, never forced on.
    const [showBonusOverlay, setShowBonusOverlay] = useState(false);
    // JOGADA GRÁTIS panel in the footer: free spins left at 1x/2x/3x/5x, or null
    // for the control buttons. Driven by the game result's remainingFreeSpin
    // (how many are left) and freePlayBonus (their multiplier), once the reels stop.
    const [freeSpinCounts, setFreeSpinCounts] = useState(null);
    const freeSpinsLeftRef = useRef(0);
    // multiplier whose "Nx" animation the JOGADA GRÁTIS reel symbols play, or null
    const [freePlayAnim, setFreePlayAnim] = useState(null);
    // multiplier of the free play that is running; every win in it is paid that
    // many times (freeplaybonus.mp4: "Ganhou 3 x 1250 = 3750")
    const freePlayMultRef = useRef(1);
    // the Ganhou line of a free spin win: { multiplier, base, total }, or null
    const [freePlayWin, setFreePlayWin] = useState(null);
    // Ganho Total of the free play so far; the machine shows it in place of
    // BOA SORTE!!! while free spins roll. null outside free play.
    const [freePlayTotal, setFreePlayTotal] = useState(null);
    const freePlayTotalRef = useRef(null);

    const [activeBonus, setActiveBonus] = useState(null);

    const [animationTimeOutRef, setAnimationTimeOutRef] = useState([]);
    const [animationIntervalRef, setAnimationIntervalRef] = useState([]);
    const [autoBetTimeOutRef, setAutoBetTimeOutRef] = useState(null);

    const currency = getDataFromStore(CURRENCY_CODE);

    useEffect(() => {
        getWalletBalance();
        getTemplateData();
    }, [templateId]);

    useEffect(() => {
        if (autoCount > 0 || autoCount === -1) {
            placeBet();
        } else {
            setAutoBetOn(false);
            setAutoCount(0);
        }
    }, [playMachine]);

    const getWalletBalance = () => {
        callGetApi(GET_PLAYER_BALANCE_GET, {}, (response) => {
            if (response.errorCode === 0) {
                // mid free play (page refreshed) the header keeps the Créditos the free
                // play started from; its wins only land there at the end (settleFreeSpin)
                const saved = readFreePlay();
                const held = saved?.left > 0 && saved.baseBalance != null ? saved.baseBalance : null;
                setWalletBalance(held ?? Math.round(response.responsePacket * 100.0) / 100.0);
            }
        });
    };

    const getTemplateData = () => {
        if (!templateId) return;
        callGetApi(GET_TEMPLATE_DETAILS_GET.replaceAll("{recordId}", templateId), {}, (response) => {
            if (response.errorCode === 0) {
                const res = response.responsePacket;
                setKeyboardInput(res.keyboardInput);
                setAccumuladoList(res?.accumuladoList || []);
                restoreFreePlay(res?.remainingFreeSpin);
                setTemplateData(res);
                setBetMultiplier(res.betAmountList[0]);
            }
        });
    };

    // ---------------- sound ----------------
    /* The credits counter is the one sound here that has to LOOP: the same 0.94s
       clip runs over and over for as long as the payout takes. An <audio loop> is
       not good enough for that — at every wrap it seeks back to 0 and re-primes
       the decoder, and that pause is audible: the clip sounds like it stopped and
       started again instead of running continuously. A buffer source loops
       sample-accurately, which is what the clip's crossfaded seam needs to hold.
       Same trick as the pumpkin background loop in BombaCauldronAboboraBonus.
       The <audio> element stays as the fallback where Web Audio is unavailable.

       The clip is a .wav on purpose. An mp3 carries encoder delay and padding,
       and whether decodeAudioData strips them is up to the browser — any that
       does not would put that silence back at the top of every repeat, which is
       the exact stutter this is here to remove. A wav has no such framing. */
    const countingAudioRef = useRef({ ctx: null, buffer: null, source: null, gain: null, mix: 1.0 });

    useEffect(() => {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return undefined;
        const ctx = new AudioCtx();
        countingAudioRef.current.ctx = ctx;
        let cancelled = false;
        fetch("assets/ice-bonus/number-coin-sound.wav")
            .then((res) => res.arrayBuffer())
            .then((data) => ctx.decodeAudioData(data))
            .then((buffer) => {
                if (!cancelled) countingAudioRef.current.buffer = buffer;
            })
            .catch((err) => console.warn("Counter loop preload failed, using the <audio> tag.", err));
        return () => {
            cancelled = true;
            countingAudioRef.current.buffer = null;
            if (ctx.state !== "closed") ctx.close().catch(() => { });
        };
    }, []);

    const stopCountingSound = () => {
        const counter = countingAudioRef.current;
        if (counter.source) {
            try { counter.source.stop(); } catch (e) { /* already stopped */ }
            counter.source.disconnect();
            counter.source = null;
            counter.gain = null;
        }
        const el = $("#CreditsCounterMp3")[0];
        if (el) {
            el.pause();
            el.currentTime = 0;
        }
    };

    // Volume is the player's own level, halved while an accumulado win counts —
    // the <audio> path used a bare 0.5/1.0, but a gain node is not covered by
    // setSoundLevelOfAudio's .audioFile sweep, so the level has to be read here
    // or the counter would ignore the volume button entirely.
    const startCountingSound = (accumWin) => {
        const counter = countingAudioRef.current;
        counter.mix = accumWin > 0 ? 0.5 : 1.0;
        const level = getAudioVolume() * counter.mix;
        if (counter.ctx && counter.buffer) {
            stopCountingSound();
            const gain = counter.ctx.createGain();
            gain.gain.value = level;
            const source = counter.ctx.createBufferSource();
            source.buffer = counter.buffer;
            source.loop = true;
            source.connect(gain);
            gain.connect(counter.ctx.destination);
            source.start(0);
            counter.source = source;
            counter.gain = gain;
            // the context stays suspended until the page has been interacted with
            if (counter.ctx.state === "suspended") counter.ctx.resume().catch(() => { });
            return;
        }
        const el = $("#CreditsCounterMp3")[0];
        if (!el) return;
        el.volume = level;
        el.loop = true;
        el.play().catch(() => { });
    };

    const playSoundById = (soundTagId) => {
        const audio = $("#" + soundTagId)[0];
        if (audio) audio.play().catch(() => { });
    };

    const setSoundLevelOfAudio = (level) => {
        $(".audioFile").prop("volume", level);
        // the counter is on Web Audio, so it is not one of the .audioFile elements
        const counter = countingAudioRef.current;
        if (counter.gain) counter.gain.gain.value = level * counter.mix;
    };

    const setNextSoundLevelOfAudio = () => {
        playSoundById("ButtonClickMp3");
        let v = getAudioVolume();
        v = v === 0 ? 0.25 : v === 0.25 ? 0.5 : v === 0.5 ? 0.75 : v === 0.75 ? 1.0 : 0;
        setAudioVolume(v);
        setSoundLevelOfAudio(v);
        $("#audioVolume").prop("src", "/assets/img/sound/sound-" + v.toFixed(2) + ".png");
    };

    // remainingFreeSpin > 0 opens the panel with that many under the freePlayBonus
    // tub; 0 (or missing) closes it and brings the control buttons back.
    // When the count goes UP, this spin is the one that awarded them: the JOGADA
    // GRÁTIS symbols on the reels play their "Nx" animation (freeplaybonus.mp4).
    const applyFreeSpins = (result) => {
        const left = result?.remainingFreeSpin || 0;
        const before = freeSpinsLeftRef.current;
        freeSpinsLeftRef.current = left;
        if (left <= 0) {
            // Ganho Total stays up: settleFreeSpin pays it out and then clears it
            setFreeSpinCounts(null);
            saveFreePlay();
            return;
        }
        const multiplier = result?.freePlayBonus || 1;
        freePlayMultRef.current = multiplier;
        setFreeSpinCounts({ 1: 0, 2: 0, 3: 0, 5: 0, [multiplier]: left });
        if (left > before) {
            setFreePlayAnim(multiplier);
            if (before <= 0) {
                // the spin that awards the free play is not paid either (bonus-amaunt.mp4
                // opens on it: Ganho Total 17570, Pago blank, Créditos untouched) — its
                // win starts Ganho Total and is paid with the rest at the end
                const win = result?.bonusType === "None" && !(result?.accumuladoActual > 0) ? (result?.winnings || 0) : 0;
                if (win > 0) result.awardedFreePlay = true;
                setFreePlayTotalValue(win);
            }
        }
        saveFreePlay();
    };

    const setFreePlayTotalValue = (v) => {
        freePlayTotalRef.current = v;
        setFreePlayTotal(v);
        saveFreePlay();
    };

    // A refresh must not lose the free play: the spins left, their multiplier,
    // Ganho Total so far and the Créditos it started from (which the header holds
    // until the end) are kept in localStorage per template and put back on load.
    // Cleared once the free play has been paid out.
    const freePlayBaseRef = useRef(null);
    const freePlayRestoredRef = useRef(false);
    const freePlayKey = `ice_free_play_${templateId}`;
    const readFreePlay = () => {
        try {
            return JSON.parse(localStorage.getItem(freePlayKey)) || null;
        } catch (e) {
            return null;
        }
    };
    const saveFreePlay = () => {
        try {
            const left = freeSpinsLeftRef.current;
            const total = freePlayTotalRef.current;
            if (left > 0 || total != null) {
                localStorage.setItem(freePlayKey, JSON.stringify({
                    left, multiplier: freePlayMultRef.current, total: total || 0, baseBalance: freePlayBaseRef.current,
                }));
            } else {
                localStorage.removeItem(freePlayKey);
                freePlayBaseRef.current = null;
            }
        } catch (e) { /* storage blocked: the free play just won't survive a refresh */ }
    };
    // `serverLeft` is remainingFreeSpin from the template details, when the API sends it
    const restoreFreePlay = (serverLeft) => {
        const saved = readFreePlay();
        const left = typeof serverLeft === "number" ? serverLeft : (saved?.left || 0);
        if (left <= 0) {
            if (saved) {
                // finished (or paid) while away: drop it and take the real balance
                try { localStorage.removeItem(freePlayKey); } catch (e) { /* ignore */ }
                getWalletBalance();
            }
            return;
        }
        const multiplier = saved?.multiplier || 1;
        freeSpinsLeftRef.current = left;
        freePlayMultRef.current = multiplier;
        freePlayBaseRef.current = saved?.baseBalance ?? null;
        freePlayRestoredRef.current = true;
        setFreeSpinCounts({ 1: 0, 2: 0, 3: 0, 5: 0, [multiplier]: left });
        setFreePlayTotalValue(saved?.total || 0);
    };

    // A free spin's win is paid `multiplier` times. The per-line boxes keep the
    // plain line value (1250), only the total is multiplied. If the backend has
    // already multiplied `winnings` (it is no longer the sum of the lines), it is
    // left alone so nothing gets paid twice.
    const applyFreePlayMultiplier = (result, multiplier) => {
        const base = Math.round((result.payLines || []).reduce((s, pl) => s + (pl.winnings || 0), 0) * 100) / 100;
        if (!(base > 0)) return null;
        if (Math.abs((result.winnings || 0) - base) < 0.01) {
            result.winnings = Math.round(base * multiplier * 100) / 100;
        }
        return { multiplier, base, total: result.winnings };
    };

    // A free spin win plays out in three steps (videofree.mp4, the 3x spin):
    //   multiply  "Ganhou / 3 x 2510 = 7530" held FP_MULT_HOLD_MS — the recording
    //             holds it ~1.75s, held longer here by request so it can be read
    //   plus      Ganho Total counts up by the win (83834 -> 91364)
    //   pay       the win counts into Créditos / Pago (playWinningAnimation, which
    //             waits FP_PAYOUT_DELAY_MS for the two steps above)
    // Runs once per win even if the reels are stopped early and the normal stop
    // then runs too, so Ganho Total never counts a win twice.
    const FP_MULT_HOLD_MS = 3000;
    const FP_PLUS_MS = 1000;
    const FP_PAYOUT_DELAY_MS = FP_MULT_HOLD_MS + FP_PLUS_MS + 500;
    const showFreePlayWin = (fp) => {
        if (!fp || fp.shown) return;
        fp.shown = true;
        setFreePlayWin({ ...fp, stage: "multiply" });
        setTimeout(() => {
            setFreePlayWin({ ...fp, stage: "plus" });
            const from = freePlayTotalRef.current || 0;
            const to = from + fp.total;
            const steps = 20;
            let i = 0;
            const interval = setInterval(() => {
                i += 1;
                setFreePlayTotalValue(i >= steps ? to : Math.round(from + ((to - from) * i) / steps));
                if (i >= steps) clearInterval(interval);
            }, FP_PLUS_MS / steps);
        }, FP_MULT_HOLD_MS);
    };

    // Free play pays nothing while it rolls (bonus-amaunt.mp4): each win only adds
    // to Ganho Total and Créditos stays where it was (79211 for the whole run).
    // After the LAST free spin the whole Ganho Total counts into Créditos at once:
    // Ganho Total counts down while Pago and Créditos count up, Pago ending on the
    // total. Runs once per spin, whichever stop path gets here first.
    const FP_FINAL_HOLD_MS = 500;
    const settleFreeSpin = (balance, result) => {
        if (result.fpSettled) return;
        result.fpSettled = true;
        const last = !(result.remainingFreeSpin > 0);
        setButtonFlag(true);
        setJogarButtonFlag(true);
        setTimeout(() => {
            setFreePlayWin(null);
            const total = freePlayTotalRef.current || 0;
            if (last && total > 0) {
                playWinningAnimation(balance, total, 0, -1, FP_FINAL_HOLD_MS, true);
                return;
            }
            setWinnings(0);
            if (last) setFreePlayTotalValue(null);
            setButtonFlag(false);
            setJogarButtonFlag(false);
        }, result.freePlayWin ? FP_PAYOUT_DELAY_MS : result.awardedFreePlay ? 1700 : 0);
    };

    // ---------------- stop / settle ----------------
    const stopAllAnimation = () => {
        const slotAudio = $("#SlotMp3")[0];
        if (slotAudio) {
            slotAudio.pause();
            slotAudio.currentTime = 0;
        }
        setAnimateColumn([false, false, false, false, false]);
        setSlotRunning(false);
        animationTimeOutRef.forEach(clearTimeout);
        animationIntervalRef.forEach(clearInterval);
        drawWinningLineOnResult(gameResult);

        stopCountingSound();
        setWinnings(0);

        if (!gameResult) return;
        showFreePlayWin(gameResult.freePlayWin);
        applyFreeSpins(gameResult);
        const lastBalance = walletBalance;
        if ((gameResult.isFreeSpin || gameResult.awardedFreePlay) && gameResult.bonusType === "None" && !(accumuladoWin.winAmount > 0)) {
            settleFreeSpin(lastBalance, gameResult);
        } else if (gameResult.winnings > 0 || accumuladoWin.winAmount > 0) {
            setButtonFlag(true);
            setWinnings(gameResult.winnings);
            if (gameResult.bonusType === "None") {
                if (accumuladoWin.winAmount > 0) {
                    playAccumuladoShow(lastBalance, gameResult.winnings, accumuladoWin.winAmount, accumuladoWin.winIndex);
                } else {
                    playWinningAnimation(lastBalance, gameResult.winnings, accumuladoWin.winAmount, -1);
                }
            }
        }
        if (gameResult.bonusType !== "None") {
            openBonusModel(gameResult.bonusType);
        } else {
            setButtonFlag(false);
        }
    };

    // Only the fridge and the basket exist here. Anything else the backend might
    // send is not a bonus this game can play, so the round just ends normally.
    const openBonusModel = (bonusType) => {
        if (bonusType !== FRIDGE_BONUS_TYPE && bonusType !== BASKET_BONUS_TYPE) {
            setButtonFlag(false);
            return;
        }
        setTimeout(() => {
            setActiveBonus(bonusType);
            setShowBonusOverlay(true);   // BÔNUS splash first, the bonus opens when it ends
        }, 2000);
    };

    // ---------------- bet / spin ----------------
    const placeBet = () => {
        if (jogarButtonFlag) return;
        setPagoWinningCounter(null);
        setPagoCountsUp(false);
        setShowAutoNumberPickerModel(false);
        setWinningLines([]);
        setBonusLines(null);
        setHighlightCells([]);
        setFreePlayAnim(null);
        setFreePlayWin(null);
        setLinePreview(false);   // stop previewing selected lines once a spin starts

        // a free spin costs nothing and pays its win `freePlayMult` times
        const isFreeSpin = freeSpinsLeftRef.current > 0;
        const freePlayMult = freePlayMultRef.current;
        if (!isFreeSpin) setFreePlayTotalValue(null);
        else if (freePlayBaseRef.current == null) {
            // the Créditos the whole free play is held at, for a refresh to put back
            freePlayBaseRef.current = walletBalance;
            saveFreePlay();
        }
        const totalBetAmount = (betMultiplier || 0) * selectedNumber;
        if (!totalBetAmount) return;

        if (!isFreeSpin && walletBalance < totalBetAmount) {
            playSoundById("ErrorMp3");
            setShowInsufficientFundModel(true);
            setTimeout(() => setShowInsufficientFundModel(false), 3000);
            setAutoBetOn(false);
            setAutoCount(0);
            return;
        }
        if (autoBetTimeOutRef !== null) clearTimeout(autoBetTimeOutRef);

        playSoundById("SlotMp3");
        setButtonFlag(true);
        setJogarButtonFlag(true);
        setSlotRunning(true);
        setWinnings(0);
        setGameResult(null);
        setAnimateColumn([true, true, true, true, true]);

        const payload = {
            slotLineType: `Line_${selectedNumber}`,
            betAmount: getFormattedAmountWithDenomination(totalBetAmount, denomination),
        };
        const lastBalance = walletBalance;
        if (!isFreeSpin) setWalletBalance(Math.round((lastBalance - totalBetAmount) * 100) / 100.0);

        const pTimeouts = [];

        callPostApi(GET_GAME_PLAY_RESULT_POST.replaceAll("{templateId}", templateId), payload, {}, (response) => {
            setJogarButtonFlag(false);
            if (response.errorCode === 0) {
                const result = response.responsePacket;
                const accumuladoWinningAmt = result?.accumuladoActual;
                // shown when the reels stop, with the rest of the win (showFreePlayWin)
                result.freePlayWin = isFreeSpin ? applyFreePlayMultiplier(result, freePlayMult) : null;
                result.isFreeSpin = isFreeSpin;
                setKeyboardInput(result.keyboardInput);
                setGameResult(result);
                setReels(matrixToReels(result.resultMatrix));

                let winningIndex = -1;
                const list = result?.accumuladoList;
                if (Array.isArray(list) && list.length) {
                    winningIndex = list.findIndex((i) => i.accumuladoActual === 0);
                    if (winningIndex !== -1 && accumuladoWinningAmt > 0) {
                        list[winningIndex].accumuladoActual = accumuladoWinningAmt;
                        setAccumuladoWin({ winAmount: accumuladoWinningAmt, winIndex: winningIndex });
                    } else {
                        setAccumuladoWin({ winAmount: 0, winIndex: -1 });
                    }
                    setAccumuladoList(list);
                }

                // reels stop one by one
                [1500, 2000, 2500, 3000].forEach((ms, i) => {
                    pTimeouts.push(setTimeout(() => {
                        setAnimateColumn((prev) => {
                            const next = [...prev];
                            next[i] = false;
                            return next;
                        });
                    }, ms));
                });

                pTimeouts.push(setTimeout(() => {
                    setAnimateColumn((prev) => {
                        const next = [...prev];
                        next[4] = false;
                        return next;
                    });
                    const slotAudio = $("#SlotMp3")[0];
                    if (slotAudio) {
                        slotAudio.pause();
                        slotAudio.currentTime = 0;
                    }
                    drawWinningLineOnResult(result);
                    showFreePlayWin(result.freePlayWin);
                    applyFreeSpins(result);

                    if (result.bonusType === "None") {
                        const roundAccWin = accumuladoWinningAmt || 0;
                        if (roundAccWin > 0) {
                            playAccumuladoShow(walletBalance, result.winnings, roundAccWin, winningIndex);
                        } else if (isFreeSpin || result.awardedFreePlay) {
                            settleFreeSpin(walletBalance, result);
                        } else {
                            playWinningAnimation(walletBalance, result.winnings, 0, -1);
                        }
                    } else {
                        openBonusModel(result.bonusType);
                    }
                }, 3500));

                pTimeouts.push(setTimeout(() => {
                    setSlotRunning(false);
                    setButtonFlag(result.winnings > 0);
                }, 4000));

                // auto-bet chaining
                let autoTimer = 7500;
                if (result?.winnings <= 0) autoTimer = 4000;
                else if (result.freePlayWin) autoTimer = 4000 + FP_PAYOUT_DELAY_MS;   // the free play win steps, no payout
                // the last free spin pays the whole Ganho Total out
                if (isFreeSpin && !(result.remainingFreeSpin > 0)) autoTimer = 4000 + (result.freePlayWin ? FP_PAYOUT_DELAY_MS : 0) + FP_FINAL_HOLD_MS + 6000;
                if (accumuladoWinningAmt > 0) autoTimer = 38500;
                if (autoBetOn && result.bonusType === "None") {
                    const t = setTimeout(() => {
                        setAutoCount((c) => (c > 0 ? c - 1 : c === 0 ? 0 : -1));
                        setPlayMachine((p) => p + 1);
                    }, autoTimer);
                    setAutoBetTimeOutRef(t);
                    pTimeouts.push(t);
                }

                setAnimationTimeOutRef(pTimeouts);
            } else if (response.errorCode === 1001) {
                toast.error(response.message);
                window.location.reload();
            } else {
                toast.error(response.message);
                setButtonFlag(false);
                setJogarButtonFlag(false);
                setSlotRunning(false);
                setWalletBalance(Math.round(lastBalance * 100) / 100.0);
                setAnimateColumn([false, false, false, false, false]);
            }
        }, (error) => {
            toast.error(error);
            setButtonFlag(false);
            setJogarButtonFlag(false);
            setSlotRunning(false);
            setWalletBalance(Math.round(lastBalance * 100) / 100.0);
            setAnimateColumn([false, false, false, false, false]);
        });
    };

    // highlight the winning pay-lines (ice equivalent of the line-show classes)
    const drawWinningLineOnResult = (pGameResult) => {
        if (!pGameResult || !Array.isArray(pGameResult.payLines) || !pGameResult.winnings) return;
        setJogarButtonFlag(true);
        if (pGameResult.winnings > 0) setWinnings(pGameResult.winnings);
        if (pGameResult.payLines.length > 0) playSoundById("PremioRodilho");
        setWinningLines(payLineNumbers(pGameResult.payLines));
        // bonus lines: each payLine carries its OWN `winnings`, shown in that line's box
        const bonus = {};
        // winning symbols: coordinates flagged `isValidToDrawLine` (same as Halloween_20's matchbox),
        // plus the runs read off the matrix from both ends (right-to-left wins come unflagged)
        const cells = [];
        const addCell = (c) => {
            if (!cells.some((k) => k.x === c.x && k.y === c.y)) cells.push({ x: c.x, y: c.y });
        };
        pGameResult.payLines.forEach((pl) => {
            const n = parseInt(String(pl.title).replace("line-show", ""), 10);
            if (!isNaN(n)) bonus[n] = Math.round(pl.winnings || 0);
            (pl.line || []).forEach((c) => {
                if (c.isValidToDrawLine) addCell(c);
            });
            lineRunCells(pl, pGameResult.resultMatrix).forEach(addCell);
        });
        setBonusLines(bonus);
        setHighlightCells(cells);

        // TEMPORARY (dev only) — dumps what the server sent against what we draw, so the
        // pay-line/highlight mismatch can be pinned down. Delete this block once fixed.
        if (process.env.NODE_ENV === "development") {
            const grid = (pGameResult.resultMatrix || []).map((row, r) =>
                `row${r}: ` + (row || []).map((c) => String(c?.title ?? "?")).join(" | ")
            );
            /* eslint-disable no-console */
            console.group("%c[ICE payline debug]", "background:#0b6;color:#fff;padding:2px 6px");
            console.log("resultMatrix (row-major, 3 rows x 5 reels):\n" + grid.join("\n"));
            console.log("lines we will draw (num-line-N.png):", payLineNumbers(pGameResult.payLines));
            pGameResult.payLines.forEach((pl) => {
                console.log(
                    `payLine "${pl.title}"  winnings=${pl.winnings}`,
                    (pl.line || []).map((c) => `x=${c.x},y=${c.y}${c.isValidToDrawLine ? " *WIN*" : ""}`)
                );
            });
            console.log("cells we highlight as {x:row, y:col}:", JSON.stringify(cells));
            console.groupEnd();
            /* eslint-enable no-console */
        }
    };

    // ---------------- winnings animations (same as Halloween_20) ----------------
    // The ACUMULADO show (25s of letters and coins). While the coins rain, the pot
    // comes down too, ONE BY ONE: a stream of 1s flies from the header value into
    // the footer's Ganhou box (the path in jackpot-amount.mp4), and each adds to
    // Ganhou as it lands — 1600 -> 1601 -> 1602 -> ... -> 2100. A pot bigger than
    // ACC_MAX_PIECES comes down in ACC_MAX_PIECES bigger pieces instead (200000 ->
    // pieces of 400). The header pot counts DOWN as each piece leaves it
    // (500.0 -> 499.0 -> ... -> 0.0), so the money visibly moves from the pot into
    // Ganhou. When the show ends the payout takes over (phase 2).
    const ACC_SHOW_MS = 25000;
    const ACC_MAX_PIECES = 500;
    const ACC_FIRST_PIECE_MS = 2000;   // the coins start ~0.8s in, the A lands ~2.7s
    const ACC_STREAM_MS = 19000;       // launches spread over 2s..21s; the last lands ~22.4s
    const playAccumuladoShow = (currentBalance, win, accumWin, accIndex) => {
        setShowCoins(true);
        setWinnings(win);
        const n = Math.min(ACC_MAX_PIECES, Math.max(1, Math.floor(accumWin)));
        const base = Math.floor(accumWin / n);
        let added = 0;
        const addPiece = (amount) => {
            added += amount;
            setWinnings(win + added);
        };
        let launched = 0;
        const takeFromPot = (amount) => {
            launched += amount;
            const left = Math.max(0, Math.round((accumWin - launched) * 100) / 100);
            setAccumuladoList((prev) => {
                if (!Array.isArray(prev) || !prev[accIndex]) return prev;
                const next = [...prev];
                next[accIndex] = { ...next[accIndex], accumuladoActual: left };
                return next;
            });
        };
        for (let i = 0; i < n; i++) {
            const amount = i === n - 1 ? accumWin - base * (n - 1) : base;   // the last piece takes the remainder
            setTimeout(() => {
                const id = `${Date.now()}-${i}`;
                takeFromPot(amount);
                setJackpotFlies((prev) => [...prev, {
                    id,
                    amount,
                    small: n > 20,
                    onArrive: () => {
                        setJackpotFlies((prev) => prev.filter((f) => f.id !== id));
                        addPiece(amount);
                    },
                }]);
            }, ACC_FIRST_PIECE_MS + Math.round((i * ACC_STREAM_MS) / n));
        }
        setTimeout(() => {
            setShowCoins(false);
            setJackpotFlies([]);
            playWinningAnimation(currentBalance, win, accumWin, accIndex);
        }, ACC_SHOW_MS);
    };

    // `accumWin` is the pot exactly as the API sends it (accumuladoActual 500.0 is
    // paid as 500 credits: line win 50 -> Pago 550.0). The header keeps showing
    // the pot through the payout; it only changes when the next spin's
    // accumuladoList arrives. `accIndex` is kept for the call sites.
    // `holdMs` is how long the win waits before it counts into the balance — the
    // free play steps (showFreePlayWin) need longer than the plain "Ganhou" hold.
    // `freePlayPayout` (the end of a free play): Pago starts at 0 and counts UP to
    // the total while Ganhou reads "Ganho Total" and counts down (pagoCountsUp
    // switches the header off its usual held total). It runs a fixed
    // FP_PAYOUT_COUNT_MS so the Pago / Valor / Créditos climb can be watched,
    // whatever the size of the total.
    const FP_PAYOUT_COUNT_MS = 4000;
    const playWinningAnimation = (currentBalance, win, accumWin, accIndex = -1, holdMs = 1700, freePlayPayout = false) => {
        const totalWin = win + accumWin;
        if (totalWin <= 0) return;

        let timeFactor = Math.min(Math.max(5000 / totalWin, 2), 20);
        if (timeFactor * totalWin < 2000) timeFactor = Math.ceil(2000 / totalWin);
        let incrementFactor = Math.max(1, Math.floor((totalWin * timeFactor) / 500));
        if (freePlayPayout) {
            timeFactor = 20;
            incrementFactor = Math.max(1, Math.ceil(totalWin / (FP_PAYOUT_COUNT_MS / timeFactor)));
        }
        const pTimeouts = [...animationTimeOutRef];
        const playAudio = () => startCountingSound(accumWin);
        const stopAudio = () => stopCountingSound();
        const finalizeAnimation = () => {
            setWinnings(0);
            setPagoWinningCounter(totalWin);
            setWalletBalance(currentBalance + totalWin * denomination);
            if (freeSpinsLeftRef.current <= 0) setFreePlayTotalValue(null);
            // a free play brought back after a refresh: settle on the server's balance
            if (freePlayPayout && freePlayRestoredRef.current) {
                freePlayRestoredRef.current = false;
                getWalletBalance();
            }
            stopAudio();
            setButtonFlag(false);
            setJogarButtonFlag(false);
        };
        // phase 2: count the win down into the balance
        const startPhase2 = (startFrom = totalWin) => {
            playAudio();
            let current = startFrom;
            const interval = setInterval(() => {
                if (current <= 0) {
                    clearInterval(interval);
                    finalizeAnimation();
                    return;
                }
                const step = Math.min(incrementFactor, current);
                current -= step;
                setWinnings(current);
                setPagoWinningCounter(totalWin - current);
                setWalletBalance((prev) => prev + step * denomination);
            }, timeFactor);
            setAnimationIntervalRef([interval]);
        };
        setButtonFlag(true);
        setJogarButtonFlag(true);
        // With an accumulado win the jackpot is already in Ganhou (playAccumuladoShow
        // dropped it in piece by piece during the overlay), so Ganhou is set to the
        // exact total, held a moment, and counts into the credits with Pago
        // stepping to the total.
        if (accumWin > 0) {
            setWinnings(totalWin);
            pTimeouts.push(setTimeout(() => startPhase2(totalWin), 1000));
        } else {
            if (freePlayPayout) {
                setWinnings(win);
                setPagoWinningCounter(0);
                setPagoCountsUp(true);
            }
            pTimeouts.push(setTimeout(() => startPhase2(win), holdMs));
        }
        setAnimationTimeOutRef(pTimeouts);
    };

    // ---------------- controls ----------------
    // clicking a line button while the reels spin stops a column (Halloween_20 behaviour)
    const stopAnimation = (lineNumber) => {
        const idx = { 1: 0, 5: 1, 9: 2, 15: 3, 20: 4 }[lineNumber];
        if (idx === undefined) return;
        setAnimateColumn((prev) => {
            const next = [...prev];
            next[idx] = false;
            return next;
        });
    };

    const drawLine = (number) => {
        playSoundById("LinhaWav");
        setSelectedNumber(number);
        setWinningLines([]);
        setLinePreview(true);   // previewing the chosen lines
    };

    const handleLineIncrease = () => {
        const i = LINE_OPTIONS.indexOf(selectedNumber);
        drawLine(LINE_OPTIONS[(i + 1) % LINE_OPTIONS.length]);
    };
    const handleLineDecrease = () => {
        const i = LINE_OPTIONS.indexOf(selectedNumber);
        drawLine(LINE_OPTIONS[(i - 1 + LINE_OPTIONS.length) % LINE_OPTIONS.length]);
    };

    const increaseBetMultiplier = () => {
        if (!templateData?.betAmountList?.length) return;
        playSoundById("LinhaWav");
        setBetMultiplier((prev) => {
            const list = templateData.betAmountList;
            const i = list.findIndex((b) => b === prev);
            return i === -1 ? list[0] : list[(i + 1) % list.length];
        });
    };
    const decreaseBetMultiplier = () => {
        if (!templateData?.betAmountList?.length) return;
        playSoundById("LinhaWav");
        setBetMultiplier((prev) => {
            const list = templateData.betAmountList;
            const i = list.findIndex((b) => b === prev);
            return i === -1 ? list[0] : list[(i - 1 + list.length) % list.length];
        });
    };
    const setMaxBet = () => {
        if (!templateData?.betAmountList?.length) return;
        playSoundById("LinhaWav");
        setBetMultiplier(templateData.betAmountList[templateData.betAmountList.length - 1]);
        drawLine(LINE_OPTIONS[LINE_OPTIONS.length - 1]);
    };

    const updateAutoCount = (pCount) => {
        setAutoCount(pCount);
        if (pCount === 0) setAutoBetOn(false);
        setAutoBetOn(true);
        setShowAutoNumberPickerModel(false);
        if (!slotRunning) setPlayMachine((p) => p + 1);
    };

    const toggleAuto = () => {
        if (!autoBetOn) {
            setAutoBetOn(true);
            setAutoCount(-1);
        } else {
            setAutoBetOn(false);
            setAutoCount(0);
        }
        setPlayMachine((p) => p + 1);
    };

    const handleCancelAutoBet = () => {
        playSoundById("ButtonClickMp3");
        setAutoCount(0);
        setAutoBetOn(false);
        setShowAutoNumberPickerModel(false);
    };

    const addBalance = () => {
        callPostApi(ADD_BALANCE_AMT_POST, {}, {}, (resp) => {
            if (resp.errorCode === 0) setWalletBalance(resp.responsePacket);
        });
    };
    const resetBalance = () => {
        callPostApi(RESET_BALANCE_AMT_POST, {}, {}, (resp) => {
            if (resp.errorCode === 0) setWalletBalance(resp.responsePacket);
        });
    };

    function formatAmount(amount) {
        let formatter;
        try {
            formatter = new Intl.NumberFormat("en-US", { style: "currency", currency, minimumFractionDigits: 2 });
        } catch (e) {
            formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
        }
        return formatter.format(amount).replace(/(\D)(\d)/, "$1 $2");
    }

    // Ice footer buttons -> game actions
    const handleButton = (key) => {
        if (showCoins) return;   // nothing works while the ACUMULADO overlay runs
        if (key === "linha_mais" || key === "linha_menos") {
            if (slotRunning) {
                stopAnimation(selectedNumber);
                return;
            }
            if (buttonFlag) return;
            key === "linha_mais" ? handleLineIncrease() : handleLineDecrease();
            return;
        }
        if (jogarButtonFlag || buttonFlag) return;
        if (key === "aposta_mais") increaseBetMultiplier();
        else if (key === "aposta_menos") decreaseBetMultiplier();
        else if (key === "ap_max") setMaxBet();
        else if (key === "auto") toggleAuto();   // same as Halloween_20's footer Auto: toggle infinite auto-play
        else if (key === "tabela") {
            playSoundById("ButtonClickMp3");
            setShowHelpModel(true);
        } else if (key === "menu") {
            playSoundById("ButtonClickMp3");
            navigate("/");   // back to the lobby (game list)
        } else if (key === "options") {
            setNextSoundLevelOfAudio();
        }
    };

    const onSpin = () => {
        if (showCoins) return;
        setAutoBetOn(false);
        setAutoCount(0);
        if (slotRunning) {
            stopAllAnimation();
        } else {
            placeBet();
        }
    };

    // ---------------- keyboard (same keys as Halloween_20) ----------------
    useEffect(() => {
        const handleKeyPress = (event) => {
            if (showCoins) return;
            const key = event.key.toLowerCase();
            const disabled = jogarButtonFlag || buttonFlag;

            if (key === "t") {
                if (!disabled) {
                    if (!showHelpModel) {
                        playSoundById("ButtonClickMp3");
                        setShowHelpModel(true);
                        setCurrentIndexOfHelpSlide(0);
                    } else {
                        advanceAjuda();
                    }
                }
            } else if (key === "y") slotRunning ? stopAnimation(1) : drawLine(1);
            else if (key === "j") slotRunning ? stopAnimation(5) : drawLine(5);
            else if (key === "h") slotRunning ? stopAnimation(9) : drawLine(9);
            else if (key === "m") slotRunning ? stopAnimation(15) : drawLine(15);
            else if (key === "n") slotRunning ? stopAnimation(20) : drawLine(20);
            else if (key === "g" && !disabled) increaseBetMultiplier();
            else if (key === "p" && !disabled) addBalance();
            else if (key === "r" && !disabled && walletBalance > 0) {
                if (!resetAmntModel) setResetAmntModel(true);
                else {
                    setResetAmntModel(false);
                    resetBalance();
                }
            } else if (key === "v" && !disabled) toggleAuto();
            else if (key === "b" && !jogarButtonFlag) onSpin();
        };
        if (activeBonus || showBonusOverlay) {
            window.removeEventListener("keydown", handleKeyPress);
        } else if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => window.removeEventListener("keydown", handleKeyPress);
        }
    }, [jogarButtonFlag, buttonFlag, showCoins, activeBonus, showBonusOverlay, keyboardInput, walletBalance, selectedNumber, betMultiplier, resetAmntModel, autoBetOn, slotRunning, showHelpModel, currentIndexOfHelpSlide]);

    // ---------------- bonus ----------------
    const onBonusRoundCompleted = (pTotalBonus) => {
        setActiveBonus(null);
        setButtonFlag(false);
        setJogarButtonFlag(false);
        if (pTotalBonus > 0) {
            setWinnings(pTotalBonus);
            if (accumuladoWin.winAmount > 0) {
                playAccumuladoShow(walletBalance, pTotalBonus, accumuladoWin.winAmount, accumuladoWin.winIndex);
            } else {
                playWinningAnimation(walletBalance, pTotalBonus, accumuladoWin.winAmount);
            }
            if (autoBetOn) {
                const countTime = accumuladoWin.winAmount > 0 ? 38000 : 5000;
                const t = setTimeout(() => {
                    setAutoCount((c) => (c > 0 ? c - 1 : c === 0 ? 0 : -1));
                    setPlayMachine((p) => p + 1);
                }, countTime);
                setAutoBetTimeOutRef(t);
            }
        }
    };

    // ---------------- AJUDA (help table) — click advances page, last click closes ----------------
    const closeAjuda = () => {
        setShowHelpModel(false);
        setCurrentIndexOfHelpSlide(0);
    };

    const advanceAjuda = () => {
        playSoundById("ButtonClickMp3");
        if (currentIndexOfHelpSlide < AJUDA_IMAGES.length - 1) {
            setCurrentIndexOfHelpSlide((i) => i + 1);
        } else {
            closeAjuda();
        }
    };

    const getHelpModel = () => (
        <ModalHalloween show={showHelpModel} toggleModel={closeAjuda}>
            <div className="modal-dialog modal-fullscreen">
                <div
                    className="modal-content ice-ajuda"
                    style={{ background: "#0a2a5e", cursor: "pointer" }}
                    onClick={advanceAjuda}
                >
                    <img
                        src={AJUDA_IMAGES[currentIndexOfHelpSlide]}
                        alt={`ajuda-${currentIndexOfHelpSlide + 1}`}
                        className="ice-ajuda-img"
                    />
                </div>
            </div>
        </ModalHalloween>
    );

    // auto count picker (10 / 25 / 50 / 100 / 250 / ∞)
    const getAutoButtonModel = () => {
        if (!showAutoNumberPickerModel) return <></>;
        return (
            <div className="ice-auto-picker">
                <div className="cursor-pointer w-100 d-flex align-items-center justify-content-center turn-btn px-2 py-1"
                    onClick={handleCancelAutoBet}>DESLIGAR</div>
                <div className="auto-digits mt-2">
                    <div className="row">
                        {[10, 25, 50, 100, 250].map((n) => (
                            <div className="col-4 mt-1" key={n}>
                                <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                                    onClick={() => updateAutoCount(n)}>{n}</div>
                            </div>
                        ))}
                        <div className="col-4 mt-1">
                            <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                                onClick={() => updateAutoCount(-1)}>∞</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // ---------------- static resources (preload + audio) ----------------
    const staticResources = {
        characters: [
            "ice-assets/game-img/spriteElement00.png", "ice-assets/game-img/spriteElement01.png", "ice-assets/game-img/spriteElement02.png",
            "ice-assets/game-img/spriteElement03.png", "ice-assets/game-img/spriteElement04.png", "ice-assets/game-img/spriteElement05.png",
            "ice-assets/game-img/spriteElement06.png", "ice-assets/game-img/spriteElement07.png", "ice-assets/game-img/spriteElement08.png", "ice-assets/game-img/spriteElement09.png",
        ],
        soundImages: [
            "/assets/img/sound/sound-0.00.png", "/assets/img/sound/sound-0.25.png",
            "/assets/img/sound/sound-0.50.png", "/assets/img/sound/sound-0.75.png",
            "/assets/img/sound/sound-1.00.png",
        ],
        audioFiles: [
            { id: "SlotMp3", src: "assets/rodilho_girando.wav" },
            { id: "Win45Wav", src: "assets/win45.wav" },
            { id: "PremioRodilho", src: "assets/ice-bonus/premio_rodilho2.wav" },
            { id: "AwardWav", src: "assets/premio.wav" },
            { id: "LinhaWav", src: "assets/linha_mais.wav" },
            { id: "ButtonClickMp3", src: "assets/standardClick.mp3" },
            { id: "ErrorMp3", src: "assets/error.mp3" },
            { id: "CreditsCounterMp3", src: "assets/ice-bonus/number-coin-sound.wav" },
        ],
    };

    const loadStaticResources = () => (
        <div style={{ display: "none" }}>
            {staticResources.characters.map((src, i) => <img key={`char-${i}`} src={src} alt="" />)}
            {staticResources.soundImages.map((src, i) => <img key={`snd-${i}`} src={src} alt="" />)}
            {staticResources.audioFiles.map((a, i) => (
                <audio key={`audio-${i}`} id={a.id} className="audioFile" controls="">
                    <source src={a.src} type={a.src.endsWith(".wav") ? "audio/wav" : "audio/mpeg"} />
                </audio>
            ))}
        </div>
    );

    const bet = betMultiplier || 0;

    return (
        <div
            className="ice-wrapper-body"
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/ice-assets/ice-wrapper-body.png)` }}
        >
            {showCoins && <AccumuladoOverlay />}
            {jackpotFlies.map((f) => <JackpotFly key={f.id} amount={f.amount} small={f.small} onArrive={f.onArrive} />)}
            {/* moving sea, in the strip game-bg-image.png leaves see-through between
                the icicles and the snow. Sits before the frame so the icicles and
                the snow paint over its edges. */}
            <div
                className="ice-ocean"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/ice-assets/line/spriteOcean.png)` }}
                aria-hidden="true"
            />
            {/* floe drifting on the water — before the frame, so the snow along the
                bottom edge cuts across it and it reads as sitting IN the sea. */}

            <div
                className="ice-float ice-float-1"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/ice-assets/line/iceBlock1.png)` }}
                aria-hidden="true"
            />
            <div
                className="ice-float ice-float-2"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/ice-assets/line/iceBlock2.png)` }}
                aria-hidden="true"
            />

            <img className="h-100 w-100 position-absolute" src={`${process.env.PUBLIC_URL}/ice-assets/game-bg-image.png`} alt="" />

            {/* crystal on the snow strip — after the frame, because the snow there is
                opaque and would bury it otherwise. */}


            <div className="ice-wrapper-main">
                {/* Pago is the spin's total win, HELD, not a counter. Checked against
                    numberCheck.mp4 at 22.4-24.0s: Pago sat on 400 the whole time while
                    Créditos climbed 2664 -> 2859 -> 2932 -> 2948.
                    pagoWinningCounter counts the money UP while `winnings` counts the
                    same money DOWN, so their sum is that total at every tick.
                    --- like the machine, Pago is BLANK when there is nothing to pay
                    (IceHeader hides a 0). Safe now that each left value is absolutely
                    pinned to its painted label, so an empty Pago moves nothing. */}
                <IceHeader
                    walletBalance={walletBalance}
                    denomination={denomination}
                    winnings={pagoWinningCounter == null ? 0 : Math.round(pagoCountsUp ? pagoWinningCounter : pagoWinningCounter + winnings)}
                    betMultiplier={bet}
                    selectedNumber={selectedNumber}
                    acumulado={accumuladoList[0]?.accumuladoActual ?? 0}
                />

                <IceMainContainer
                    reels={reels}
                    animateColumn={animateColumn}
                    lineNum={selectedNumber}
                    winningLines={winningLines}
                    linePreview={linePreview}
                    bonusLines={bonusLines}
                    highlightCells={highlightCells}
                    freePlayAnim={freePlayAnim}
                />

                {/* winnings/pago drive the line beside GIRAR — see FooterMessage.
                    BOA SORTE!!! has to hold for the WHOLE roll, so the message runs
                    off animateColumn, not jogarButtonFlag: the latter clears when
                    the API answers, ~3s before the last reel stops. */}
                <IceFooter
                    onSpin={onSpin}
                    spinning={jogarButtonFlag || showCoins}
                    locked={showCoins}
                    reelsSpinning={animateColumn.some(Boolean)}
                    onButtonClick={handleButton}
                    winnings={winnings}
                    pago={pagoWinningCounter}
                    freeSpins={freeSpinCounts}
                    freePlayWin={freePlayWin}
                    freePlayTotal={freePlayTotal}
                />


                {getAutoButtonModel()}

                {showInsufficientFundModel && (
                    <div className="ice-insufficient">Insira Creditos</div>
                )}

                {resetAmntModel && (
                    <div className="ice-insufficient">
                        <div className="ser-no-text">N.SEC. 001</div>
                        <p className="mb-0">FAVOR CHAMAR 0 OPERADOR</p>
                        <p className="mb-2">PARA RECEBER SEUS CREDITOS</p>
                        <p className="mb-0">CREDITOS: {getFormattedAmountWithDenomination(walletBalance, denomination)}</p>
                        <p className="mb-0">{formatAmount(walletBalance)}</p>
                    </div>
                )}
            </div>

            {getHelpModel()}
            {loadStaticResources()}

            {/* BÔNUS splash — plays from the centre, then the bonus itself takes over */}
            {showBonusOverlay && (
                <BonusOverlay onComplete={() => setShowBonusOverlay(false)} />
            )}

            {/* the two bonus rounds — each one asks getBonusResult for its prizes */}
            {!showBonusOverlay && activeBonus === FRIDGE_BONUS_TYPE && (
                <div style={{ position: "fixed", inset: 0, zIndex: 9999 }}>
                    <RefrigeratorBonus
                        keyboardInput={keyboardInput}
                        gameSessionRecordId={gameResult?.recordId}
                        bonusType={FRIDGE_BONUS_TYPE}
                        walletBalance={walletBalance}
                        denomination={denomination}
                        gameResult={gameResult}
                        onBonusRoundCompleted={(total) => onBonusRoundCompleted(total || 0)}
                    />
                </div>
            )}
            {!showBonusOverlay && activeBonus === BASKET_BONUS_TYPE && (
                <div style={{ position: "fixed", inset: 0, zIndex: 9999 }}>
                    <BasketBonus
                        keyboardInput={keyboardInput}
                        gameSessionRecordId={gameResult?.recordId}
                        bonusType={BASKET_BONUS_TYPE}
                        walletBalance={walletBalance}
                        denomination={denomination}
                        gameResult={gameResult}
                        onBonusRoundCompleted={(total) => onBonusRoundCompleted(total || 0)}
                    />
                </div>
            )}
        </div>
    );
};

export default HalloweenIceGame;
